// frontend/src/components/SpinningCreditCounter.js
import React, { useState, useEffect, useRef } from 'react';
import './SpinningCreditCounter.css';

const SpinningCreditCounter = ({ value, className = '' }) => {
  const [digits, setDigits] = useState([]);
  const [spinning, setSpinning] = useState(false);
  const prevValueRef = useRef(value);

  // Format to X,XXXK format
  const formatValue = (num) => {
    if (typeof num !== 'number' || isNaN(num)) {
      return '0K'; // Default for invalid input
    }
    if (num < 0) num = 0; // Ensure non-negative

    const thousands = Math.floor(num / 1000);
    // Use toLocaleString for thousands separator
    return thousands.toLocaleString('en-US') + 'K';
  };

  useEffect(() => {
    // Initialize digits on first render
    const initialFormatted = formatValue(value);
    if (digits.length === 0) {
      setDigits(initialFormatted.split(''));
    }

    // Trigger animation when value changes significantly
    if (value !== prevValueRef.current) {
      const newFormatted = formatValue(value);
      const oldFormatted = formatValue(prevValueRef.current);

      // Only trigger spin if the formatted value actually changes
      if (newFormatted !== oldFormatted) {
        setSpinning(true);
        setDigits(newFormatted.split(''));

        // Stop spinning after animation completes (duration matches CSS)
        const timer = setTimeout(() => {
          setSpinning(false);
        }, 1500); // Match the CSS animation duration

        // Update previous value ref *after* triggering animation
        prevValueRef.current = value;

        return () => clearTimeout(timer);
      } else {
        // If formatted value is the same, just update the ref
         prevValueRef.current = value;
      }
    }
  }, [value]); // Rerun effect when value changes

  return (
    <div className={`spinning-credit-counter ${className} ${spinning ? 'spinning' : ''}`}>
      <span className="credit-icon">⛁</span> {/* Optional: Credit icon */}
      <div className="digits-container">
        {digits.map((digit, index) => (
          <div key={index} className="digit-slot">
            <div
              className={`digit ${spinning && !isNaN(parseInt(digit)) ? 'spin' : ''}`} // Only spin numeric digits
              style={{ animationDelay: `${index * 80}ms` }} // Stagger animation
            >
              {digit}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SpinningCreditCounter;